<template>
  <div>

    <div class="col-xs-12 push-50">
    </div>

    
    <div  class="col-sm-12 col-md-12">

      <div  class="col-sm-12 col-md-12">
      <div class="content content-boxed">
        <div class="row">
          <div class="col-xs-12">
            <!-- Enregistrement de plan pré-enregistré -->
            <div class="block block-themed">
              <div class="block-header bg-primary-dark">
                    <ul  class="block-options">
                        <li v-if="flagDisplayAddService===0">
                            <button type="button" @click="toggleDisplayAddService()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                        </li>
                        <li v-if="flagDisplayAddService">
                            <button  type="button" @click="toggleDisplayAddService()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                        </li>
                    </ul>
                <h2 class="block-title" @click="toggleDisplayAddService()">Enregistrement de plan pre-enregistré</h2>
              </div>

              <div v-if="flagDisplayAddService" class="block-content">

                <div class="row">
                  <div class="col-xs-12">
                    <div class="form-group">
                    <label class="col-xs-12" for="example-select">Sélectionner un type de plan / Select plan type</label>
                      <select v-model="transmitDataModel.subscriptionTemplate" class="form-control" size="1">
                                <option v-for="plan in planDescription" v-bind:value=plan.PlanTemplate>{{ plan.Title[actualLanguage] }}</option>
                      </select>
                    </div>
                  </div>

                  <div v-if="transmitDataModel.subscriptionTemplate != 'ND'" class="col-xs-12">
                      <div class="col-sm-12 col-md-4">
                        <label for="manufacturier">Duréé gratuit (mois)</label>
                        <input type="text" v-model="transmitDataModel.monthFree">
                      </div>

                      <div class="col-sm-12 col-md-4">
                        <p><button @click="generatePreRegisteredPlan()" type="button" class="btn btn-success" name="button">Génerer le plan / Generate plan</button></p>
                      </div>
                  </div>
                  
                  <div v-if="flagPlanCodeReceived" class="col-xs-12">
                    <h4>Code du plan / Plan code:      {{PlanCode}}</h4>
                    <h4>Code de validation / Validation code:      {{ValidationCode}}</h4>

                  </div>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>

 
    <!-- END Enregistrement de plan pré-enregistré -->


    <div class="col-sm-12 col-md-12">
      <view-edit-manual-invoice :inputData="tableData"></view-edit-manual-invoice>
    </div>

    <div class="col-sm-12 col-md-12">
      <view-edit-integrator-data :inputData="tableData"></view-edit-integrator-data>
    </div>


   <!-- Lecture des log de clients -->
   <div class="col-sm-12 col-md-12">
      <div class="content content-boxed">
        <div class="row">
          <div class="col-xs-12">
            <div class="block block-themed">
              <div class="block-header bg-primary-dark">
                    <ul  class="block-options">
                        <li v-if="flagDisplayReadEventLog===0">
                            <button type="button" @click="toggleDisplayReadEventLog()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                        </li>
                        <li v-if="flagDisplayReadEventLog">
                          <button  type="button" @click="toggleDisplayReadEventLog()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                        </li>
                    </ul>
                <h2 class="block-title" @click="toggleDisplayReadEventLog()">Lecture des Event Log</h2>
              </div>

              <div v-if="flagDisplayReadEventLog" class="block-content">

                <div class="row">
                  <div class="col-xs-12">

                          <div class="row">
                            <div class="col-sm-12 col-md-4">
                              <label for="manufacturier">Email</label>
                              <input type="text" v-model="readEventLogDataModel.profileid">
                            </div>

                            <div class="col-sm-12 col-md-4">
                              <label for="manufacturier">Date de début</label>
                              <input type="text" v-model="readEventLogDataModel.startDate">
                            </div>

                            <div class="col-sm-12 col-md-4">
                              <p><button @click="getUserEventLogs()" type="button" class="btn btn-success" name="button">Lire Log</button></p>
                            </div>
                          </div>
                          <hr size="50">
        <!--
                          <table class="table remove-margin-b font-s13">
                            <thead>
                              <tr>
                                <th>Timestamp</th>
                                <th>Action</th>
                                <th>Detail</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="logLine in this.eventLogData">
                                <td class="font-w600 text-muted">{{ logLine.timestamp }}</td>
                                <td class="font-w600 text-success " >{{ logLine.Action }}</td>
                                <td class="font-w600 text-success " >{{ logLine.Details }}</td>
                              </tr>
                            </tbody>
                          </table>
        -->
                          <div class="row">
                            <div class="col-xs-12">
                              <div v-if="loadingData">
                                <spinner :message="`Téléchargement des données`"></spinner>
                              </div>
                              <div v-else>
                                    <dynamic-table :tableDataObj="tableData"></dynamic-table>
                              </div>
                            </div>
                          </div>

                      </div>
                      
                </div>
              </div>
            </div>
          </div>                                               
        </div>
      </div>
    </div>
    <!-- Lecture des log de clients --> 



    

    <div class="col-sm-12 col-md-12">
      <p><button @click="testCall()" type="button" class="btn btn-success" name="button">BOUTON TEST</button></p>
    </div>



</div>






</div>




</template>


<script>

import Spinner from '@/components/Spinner'
import DynamicTable from '@/components/DynamicDataTable1'
import ViewEditManualInvoice from './ViewEditManualInvoice'
import ViewEditIntegratorData from './ViewEditIntegratorData'
import _ from 'underscore'
import {mapState, mapActions, mapGetters} from 'vuex'


export default {
  name: 'GroupIndex',

  data() {
    return {
      isOpen : true,
      dataTempo01 : 'test',
      dataTempo02 : 'test',
      loadingData : false,
      flagDisplayAddService : 0,
      flagDisplayUploadSubscription : false,
      flagDisplayReadEventLog : 0,
      displayMessage : '--',


      moduleBindingData : '',
      codeConfirmed : false,
      transmitDataModel: {
        deviceId: '',
        deviceKey: '',
        monthFree: '36',
        subscriptionTemplate: 'ND',
      },

      planDescription : {},
      flagShowPlanListOption : false,
      flagPlanCodeReceived : false,
      PlanCode : '',
      ValidationCode : '',

      readEventLogDataModel: {
        profileid: '',
        startDate: '2020-01-01',
      },

      tableData: {
        tableTitle: [{FR: 'TimeStamp', EN: 'Timestamp'},{FR: 'Action', EN: 'Action'},{FR: 'Detail', EN: 'Detail'}],
        tableData: [
                      ['Vide', 'Vide', 'Vide',],
    ],
        flagDisplayHistogramSection: false,
    },
      eventLogData : [],
      actualLanguage : "FR",

    }
  },
  components: {
    Spinner,
    DynamicTable,
    ViewEditManualInvoice,
    ViewEditIntegratorData
  },
  computed: {
    ...mapState('sessionStore', ['userEmail','profileData','planTransactionData','actualBundle','authToken','idToken']),
    ...mapState('devicesStore',['devices', 'devicesPortData']),
  },


  methods: {
    ...mapActions('overlayStore', ['showModal']),

   toggleDisplayAddService(){
      this.flagDisplayAddService = ~this.flagDisplayAddService
    },
   toggleDisplayReadEventLog(){
      this.flagDisplayReadEventLog = ~this.flagDisplayReadEventLog
    },

    getUserPlanList(){
      var requestData = { 'postAction':'GetUserPlanList',
                          'subscriptionListId': process.env.VAR_PLAN_USER_LIST,
                          }
      //console.log(requestData)
      this.$store.dispatch('sessionStore/processSubscription', requestData)
        .then((response) => {
          //console.log(response)
          if(response.data.Code=='OK'){
            //console.log('--PLAN LIST---')
            //console.log(response.data)
            this.planDescription = response.data.PlanList
            }
            else{ window.alert(response.data.PromptMessage[this.actualLanguage] )}
        })
    },


    generatePreRegisteredPlan(){
      var requestData = { 'postAction':'GeneratePreRecordedPlan',
                          'template': this.transmitDataModel.subscriptionTemplate,
                          'freemonth':this.transmitDataModel.monthFree,
                          }
      this.flagPlanCodeReceived = false
      this.$store.dispatch('sessionStore/processSubscription', requestData)
        .then((response) => {
          //console.log(response)
          if(response.data.Code=='OK'){
            //console.log('--PLAN LIST---')
            //console.log(response.data)
            this.PlanCode = response.data.PlanCode
            this.ValidationCode = response.data.ValidationCode
            this.flagPlanCodeReceived = true
            //this.planDescription = response.data.PlanList
            //this.flagShowPlanList = true
            }
        })
    },



  getUserEventLogs() {
      this.eventLogData = [];
      this.loadingData = true
      return this.$store.dispatch('sessionStore/getEventsLog',this.readEventLogDataModel)
      .then((response) => {
        this.eventLogData = response.data.eventLogData.reverse()

        this.tableData.tableData = []
        for (let i = 0; i < this.eventLogData.length; i++) {
          this.tableData.tableData.push([this.eventLogData[i].timestamp,this.eventLogData[i].Action,this.eventLogData[i].Details]);
      }
        this.loadingData = false
        })
  },


    reloadPage(){
      window.location.reload()
    },

    toggleIsOpen(){
      this.isOpen = !this.isOpen
    },

    },

  mounted() {
    //this.getDeviceData()
    //window.location.reload()
    //console.log("Profile");
    this.readEventLogDataModel.profileid = this.profileData.profileInfo.email;
    window.scrollTo(0, 0)

    this.getUserPlanList()

    if(localStorage.language){this.actualLanguage =  localStorage.language}
    else{this.actualLanguage = 'FR'}
  }
}
</script>




// WEBPACK FOOTER //
// Index.vue?30349bf4